module.exports = __webpack_public_path__ + "static/media/logo_footer.d3fb3964.svg";